"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var SvgErrorFilled = function (props) { return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 48 48" }, props),
    React.createElement("path", { fillRule: "evenodd", d: "M27.538 1.466a5.004 5.004 0 0 0-7.076 0L1.466 20.462a5.004 5.004 0 0 0 0 7.076l18.996 18.996a5.004 5.004 0 0 0 7.076 0l18.996-18.996a5.004 5.004 0 0 0 0-7.076zm-5.04 10.527a1.501 1.501 0 1 1 3.002 0v15.01a1.501 1.501 0 1 1-3.002 0zm3.755 21.766a2.255 2.255 0 1 1-4.51 0 2.255 2.255 0 0 1 4.51 0", clipRule: "evenodd" }))); };
exports.default = SvgErrorFilled;
